<template>
  <RegionalRoadmapOverview v-if="isRegionalManager" />
  <RegionalRoadmapOverview
    v-else-if="isOrganizationAdmin && organizationRegions.length > 0"
    :selectableRegions="organizationRegions"
  />
  <StoreRoadmapOverview v-else />
</template>

<script>
import RegionalRoadmapOverview from "@/views/common/RegionalRoadmapOverview.vue";
import StoreRoadmapOverview from "@/views/common/StoreRoadmapOverview.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    RegionalRoadmapOverview,
    StoreRoadmapOverview,
  },
  computed: {
    ...mapGetters("auth", ["isRegionalManager", "isOrganizationAdmin", "organizationRegions"]),
  },
};
</script>
